import React from 'react';


function Dokumanlar(){
    return(
        <div>
            Dokümanlar sayfası.
        </div>
    )

}

export default Dokumanlar;